import * as Yup from "yup";

export const blogBannerValidation = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  banner: Yup.string().required("Banner is required"),
  image: Yup.string().required("image is required"),
});
